export default __webpack_public_path__ + "static/media/workspaces.1dea86f9.png";